var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-switch"},[_c('v-switch',{staticClass:"switch",attrs:{"hide-details":""},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}}),_c('span',[_vm._v(_vm._s(_vm.label))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }